<template>
  <div>
    <h3>Movies</h3>
  </div>
</template>
<script>
  export default {
    name: 'movies',
    data() {
      return {

      }
    },
    mounted() {
      this.$root.$firebaseRefs.anObject.once('value', function(snapshot) {
        window.console.log(snapshot.val())
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Movies.vue?e7e03038